var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-wrapper',{staticClass:"c-CollectionCard__Content",class:_vm.CSSClasses,attrs:{"tag":_vm.tag}},[_vm._t("default"),(_vm.lockedId)?_c('portal-target',{attrs:{"name":("lock-icon-" + _vm.lockedId)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }